import type { ProductCollectionSortKeys } from "@gql/types";

export type SortOption = {
  /** URL-safe key stored in ?sort= query param */
  key: string;
  sortKey: ProductCollectionSortKeys;
  reverse: boolean;
};

export const SORT_OPTIONS: Array<SortOption> = [
  {
    key: "default",
    sortKey: "COLLECTION_DEFAULT",
    reverse: false,
  },
  {
    key: "best-selling",
    sortKey: "BEST_SELLING",
    reverse: false,
  },
  {
    key: "price-asc",
    sortKey: "PRICE",
    reverse: false,
  },
  {
    key: "price-desc",
    sortKey: "PRICE",
    reverse: true,
  },
  {
    key: "newest",
    sortKey: "CREATED",
    reverse: true,
  },
  {
    key: "title-asc",
    sortKey: "TITLE",
    reverse: false,
  },
  {
    key: "title-desc",
    sortKey: "TITLE",
    reverse: true,
  },
];

const SORT_MAP = new Map(SORT_OPTIONS.map((o) => [o.key, o]));
const DEFAULT_SORT = SORT_OPTIONS[0];

export function resolveSortOption(key: string | null): SortOption {
  return (key && SORT_MAP.get(key)) || DEFAULT_SORT;
}
